// Single place for how dates are shown to users: abbreviated month, no
// leading zeros — "Sept. 9, 2026" (AP style: Jan., Feb., Aug., Sept., Oct.,
// Nov., Dec. abbreviated; March–July written out).
const MONTHS = [
  'Jan.', 'Feb.', 'March', 'April', 'May', 'June',
  'July', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.',
];

const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;

export function formatDisplayDate(value: Date | string | number | null | undefined): string {
  if (value === null || value === undefined || value === '') return '';

  let date: Date;
  if (typeof value === 'string' && DATE_ONLY.test(value)) {
    // "YYYY-MM-DD" means a calendar day, not an instant — build it in local
    // time so it doesn't shift a day back for viewers west of UTC.
    const [, y, m, d] = value.match(DATE_ONLY) as RegExpMatchArray;
    date = new Date(Number(y), Number(m) - 1, Number(d));
  } else {
    date = value instanceof Date ? value : new Date(value);
  }

  if (isNaN(date.getTime())) return typeof value === 'string' ? value : '';
  return `${MONTHS[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
}
